import { composeReducers } from 'common/util/composeReducers';
import inboxReducer from 'workflow/reducers/inbox';
import newInboxReducer from 'workflow/reducers/newInbox';
import sentboxReducer from 'workflow/reducers/sentbox';
import viewerReducer from 'workflow/reducers/viewer';
import sentBoxV4Reducer from 'workflow/reducers/sentBoxV4';

const workflowReducer = composeReducers(
    inboxReducer,
    newInboxReducer,
    sentboxReducer,
    viewerReducer,
    sentBoxV4Reducer,
);
export default workflowReducer;
